<template>
  <div class="aos-init aos-animate" data-aos="fade-up" data-aos-duration="1600" style="flex-grow: 1;">
    <div class="honor-item-wrap "  @click="handleClickItem" :class="bgImageCss">
          <div class="honor-item-box">
            <div class="item-image">
              <img :src="require('@/assets/img/'+ imagePath +'')"/>
            </div>
            <div class="title-box">
              <span>{{ mainTitle }}</span>
              <!--<img :src="require('@/assets/img/ic-right-arrow.png')"/>-->
              <div class="right-arrow"></div>
            </div>
          </div>
    </div>
  </div>
</template>

<script>
  export default {
    components: { },
    props: {
      itemType: null,
    },
    data() {
        return {
          imagePath: null,
          bgImageCss: null,
          mainTitle: null,
          routerQuery: null,
        };
      },
    methods: {
      initData(){
        if(this.itemType == 2){
            this.imagePath = 'ic-patent.png';
            this.bgImageCss = "honor-item-bg-image2";
            this.mainTitle = "所获专利";
            this.routerQuery = 'suohuozhuanli';
          }else if(this.itemType == 3){
            this.imagePath = "ic-rewards.png";
            this.bgImageCss = "honor-item-bg-image3";
            this.mainTitle = "荣誉奖励";
            this.routerQuery = 'rongyujiangli';
          }else{
            this.imagePath = "ic-ertificate.png";
            this.bgImageCss = "honor-item-bg-image1";
            this.mainTitle = "科技成就";
            this.routerQuery = 'kejichengjiu';
          }
      },

      handleClickItem(){
        this.$router.push(
          {
            path: '/rongyu',
            query:{
              tab: this.routerQuery,
            }
          }
        );
      }
    },
    created() {
      this.initData();
    },
    mounted() {

    },
    watch:{
    },
  };
</script>

<style scoped>


.honor-item-wrap{
    background: #014289;
    padding: 60px 20px;    
    cursor: pointer;    
    box-sizing: border-box; 
    transition: all 0.5s;
 }
 .honor-item-wrap::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 0px;
    background-color: #815119; 
    transition: all 0.5s;    
    z-index: -1;
}
/*
.honor-item-wrap:hover{
  background: #014289;
}
*/
.honor-item-wrap:hover {  
  background: transparent;
}

.honor-item-wrap:hover::after{
  height: 100%;  
}
.honor-item-wrap:hover img{
  -webkit-transform: rotate(360deg);
          transform: rotate(360deg);
}
/*
 .honor-item-wrap:hover{
    background: #815119;
 }
*/

 .honor-item-box{
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;    
    position: relative;
 }

 .honor-item-bg-image1{
    background-image: url('../../../assets/img/home-honor-01.png');
    background-repeat: no-repeat;    
    background-size: auto 100%;
    background-position: center center;
 }

 .honor-item-bg-image2{
    background-image: url('../../../assets/img/home-honor-02.png');
    background-repeat: no-repeat;    
    background-size: 80% auto;
    background-position: center 10px;
 }
 .honor-item-bg-image3{
    background-image: url('../../../assets/img/home-honor-03.png');
    background-repeat: no-repeat;    
    background-size: 80% auto;
    background-position: center -20px;
 }

 .item-image{
    width: 160px;
    height: 160px;
    background: rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    border: 2px dashed #FFFFFF;
    border-radius: 50%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    justify-content: center;
    align-items: center;
 }

 .item-image img{
    height: 85px;
    width: auto;
    object-fit: contain;
    -webkit-transition: all 0.5s;
    transition: all 0.5s;
 }

 .title-box{
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 24px 0px 0px 0px;
    gap: 16px;
    font-size: 32px;
    font-weight: bold;
    line-height: 36px;
    letter-spacing: 0em;
    color: #FFFFFF;
 }
 .right-arrow{
  width: 32px;
  height: 32px;
  background: url('~@/assets/icons/svg/circle-right-arrow-white.svg') no-repeat;
  background-size: cover;
 }

 @media screen and (max-width: 750px){
  .honor-item-wrap{
    padding: 30px 20px;
  }
  .item-image{
    width: 100px;
    height: 100px;
  }
  .item-image img{
    height: 60px;
    width: auto;    
  }
  .title-box{
    font-size: 14px;
    line-height: 14px;
    gap: 8px;
    padding: 16px 0 0 0;
  }
  .right-arrow{
    width: 16px;
    height: 16px;
  }
  .honor-slide{
    width: 114px;
    height: 160px;
    padding: 0px;
  }

}

@media screen and (max-width: 450px){
  .honor-item-wrap{
    padding: 20px 10px;
  }
  .item-image{
    width: 48px;
    height: 48px;
  }
  .item-image img{
    height: 30px;
    width: auto;    
  }
}
</style>



// WEBPACK FOOTER //
// src/components/blocks/honorblock/honoritem.vue